import { CommonModule } from "@angular/common";
import { afterNextRender, Component, inject, model } from "@angular/core";
import { ModalService, ProfileImageComponent } from "@client";
import { UserStore } from "../../stores/user.store";
import { Router, RouterModule } from "@angular/router";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { HeaderLayout } from "../../layout/header/header.layout";
import { Icon } from "../../../../../../libs/client-libs/src/components/icon/icon.component";
import { AlertService } from "../../services/alert.service";
import { ToastService } from "../../services/toast.service";
import { Title } from "@angular/platform-browser";

const Tabs = {
  info: "내 정보 관리 ",
  active: "내 활동",
} as const;

@Component({
  selector: "app-my-page",
  imports: [
    CommonModule,
    RouterModule,
    ProfileImageComponent,
    HeaderLayout,
    Icon,
  ],
  templateUrl: "./my-page-layout.page.html",
  styleUrl: "./my-page-layout.page.scss",
})
export default class MyPageLayoutPage {
  readonly title = inject(Title);
  readonly alertService = inject(AlertService);
  readonly toastService = inject(ToastService);
  readonly modalService = inject(ModalService);
  readonly userStore = inject(UserStore);
  readonly router = inject(Router);

  user = this.userStore.user;
  tab = model<string>(Tabs.info);
  navigationEnd$ = injectNavigationEnd();

  options = Object.values(Tabs);

  constructor() {
    this.title.setTitle("마이페이지 - XXList");

    afterNextRender(() => {
      if (this.router.url === "/my-page" && window.innerWidth > 768) {
        this.router.navigate(["/my-page/info"]);
      }

      this.handleTab();

      this.navigationEnd$.subscribe({
        next: () => {
          this.handleTab();
        },
      });
    });
  }

  handleTabChange(value: string) {
    switch (value) {
      case Tabs.info:
        this.router.navigate(["/my-page/info"]);
        break;
      case Tabs.active:
        this.router.navigate(["/my-page/active"]);
        break;
    }
  }

  getIconName(option: string) {
    switch (option) {
      case Tabs.info:
        return "solar:smile-circle-line-duotone";
      case Tabs.active:
        return "solar:document-add-outline";
      default:
        return "";
    }
  }

  handleTab() {
    const url = this.router.url;
    if (url.includes("info")) {
      this.tab.set(Tabs.info);
    } else if (url.includes("active")) {
      this.tab.set(Tabs.active);
    }
  }
  logout() {
    this.alertService
      .open({
        icon: "completed",
        title: "로그아웃",
        message: "로그아웃을 하시겠습니까?",
        button: { label: "확인" },
      })
      .closed.subscribe((result) => {
        if (result?.role === "confirm") {
          this.userStore.logout();
          this.toastService.success("로그아웃 되었습니다.");
        }
      });
  }
}
